export default __webpack_public_path__ + "static/media/screen3.b0eb89b6.jpg";